// extracted by mini-css-extract-plugin
export var addViewLink = "_g-1";
export var availabilityIcon = "_g-16";
export var availabilitySelectionIcon = "_g-15";
export var backButton = "_g-2";
export var backIcon = "_g-z";
export var conversationCount = "_g-3";
export var dragHandle = "_g-5";
export var dropdown = "_g-e";
export var dropdownIcon = "_g-7";
export var dropdownOption = "_g-6";
export var dropdownTriangle = "_g-d";
export var expand = "_g-f";
export var folder = "_g-i";
export var folderItem = "_g-c";
export var icon = "_g-8";
export var iconRow = "_g-9";
export var image = "_g-a";
export var logo = "_g-b";
export var navContainer = "_g-h";
export var navigationFooter = "_g-g";
export var pageShell = "_g-0";
export var placeholderAvailable = "_g-11";
export var placeholderBox = "_g-14";
export var placeholderBusy = "_g-13";
export var placeholderUnavailable = "_g-12";
export var profile = "_g-k";
export var profileContainer = "_g-m";
export var profileDropdown = "_g-n";
export var profileImage = "_g-l";
export var profileMain = "_g-o";
export var profileSubtitle = "_g-q";
export var profileTitle = "_g-p";
export var reorderIcon = "_g-r";
export var sentLine = "_g-u";
export var settingsHeader = "_g-s";
export var sidenavTextColor = "_g-y";
export var spamLine = "_g-t";
export var subitemWithTag = "_g-4";
export var supportItems = "_g-j";
export var teamText = "_g-10";
export var viewLine = "_g-x";
export var viewLineButton = "_g-w";
export var viewLineButtons = "_g-v";